// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1065":"beb78f69","1935":"beb78f69","2748":"beb78f69","2757":"beb78f69"}[chunkId] + ".chunk.css";
};